import { Handle, Position } from '@xyflow/react'
import { selectedBorder } from './selectedBorder.js'

export function FinalPoseNode({ data, selected }) {
  const connected    = data.connected ?? false
  const clipWeights  = data._debugClipWeights ?? {}
  const activeClips  = Object.entries(clipWeights).filter(([, w]) => w > 0.001)

  return (
    <div style={{
      background: '#1a1f2a',
      border: `2px solid ${selected ? selectedBorder(connected ? '#50a0ff' : '#304060') : connected ? '#50a0ff' : '#304060'}`,
      borderRadius: 8,
      padding: '12px 18px',
      minWidth: 180,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
      boxShadow: connected ? '0 0 12px rgba(80,160,255,0.3)' : 'none',
    }}>
      {/* Title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 20 }}>🏃</span>
        <div>
          <div style={{ color: '#80b8ff', fontWeight: 'bold', fontSize: 11 }}>FINAL ANIMATION</div>
          <div style={{ color: '#6080a0', fontSize: 10 }}>POSE</div>
        </div>
      </div>

      {/* Result input */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="result"
          style={{ background: '#50a0ff', width: 12, height: 12 }}
        />
        <span style={{ marginLeft: 18, color: connected ? '#50a0ff' : '#556677', fontSize: 11 }}>
          {connected ? '◉ Result' : '○ Result'}
        </span>
      </div>

      {/* Look input (face graph): the Look node's head / eye / blink adjustments,
          applied after the pose — not blended into it. */}
      {data._graphType === 'face' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative', marginTop: 8 }}>
          <Handle
            type="target"
            position={Position.Left}
            id="look"
            style={{ background: '#30c0e0', width: 10, height: 10, borderRadius: 2 }}
          />
          <span
            title="Plug the Look node in here. It aims the head and eyes and blinks after the pose is built, so it doesn't go through Blend nodes."
            style={{ marginLeft: 18, color: '#30c0e0', fontSize: 11, cursor: 'help' }}
          >◇ Look</span>
        </div>
      )}

      {/* Pose output — forwards the final pose to a downstream consumer (e.g. the
          OGS avatar's rig input for the splat render path). Unused in graphs that
          terminate here; harmless (GraphEvaluator only reads edges INTO 'final'). */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, position: 'relative', marginTop: 8 }}>
        <span style={{ marginRight: 18, color: '#6080a0', fontSize: 10 }}>Pose ▶</span>
        <Handle
          type="source"
          position={Position.Right}
          id="pose"
          style={{ background: '#50a0ff', width: 12, height: 12 }}
        />
      </div>

      {/* Active clips list */}
      {activeClips.length > 0 ? (
        <div style={{ marginTop: 8 }}>
          {activeClips.map(([clip, weight]) => (
            <div key={clip} style={{ marginBottom: 4 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                <span style={{ color: '#80c0ff', fontSize: 9, fontFamily: 'var(--m-mono)' }}>{clip}</span>
                <span style={{ color: '#50a0ff', fontSize: 9 }}>{(weight * 100).toFixed(0)}%</span>
              </div>
              <div style={{ height: 2, background: '#1a2a3a', borderRadius: 1 }}>
                <div style={{ width: `${weight * 100}%`, height: '100%', background: '#50a0ff', borderRadius: 1 }} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{
          marginTop: 10, padding: '3px 8px', borderRadius: 3,
          background: connected ? 'rgba(80,160,255,0.15)' : 'rgba(255,255,255,0.05)',
          color: connected ? '#50a0ff' : '#445566',
          fontSize: 10, textAlign: 'center',
        }}>
          {connected ? '▶ PLAYING' : '⏸ IDLE'}
        </div>
      )}
    </div>
  )
}
